import { render, staticRenderFns } from "./LoanManagement.vue?vue&type=template&id=63eac858"
import script from "./LoanManagement.vue?vue&type=script&lang=js"
export * from "./LoanManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports